import segment from 'util/analytics/segment'

type Action =
  | 'opened'
  | 'closed'
  | 'completed_login'
  | 'completed_sign_up'
  | 'completed_registration'
  | 'completed_update_registration'
  | 'completed_confirmation'

export interface ITrackData {
  schoolId: number
  sessionId: string
}

const events = {
  closed: 'Closed',
  completed_confirmation: 'Completed Confirmation',
  completed_login: 'Completed Login',
  completed_registration: 'Completed Registration',
  completed_sign_up: 'Completed Sign Up',
  completed_update_registration: 'Completed Update Registration',
  opened: 'Opened',
}

export function track(action: Action, data: ITrackData) {
  segment.track(`Event RSVP Modal ${events[action]}`, data)
}
